import {__} from "services/i18n";

export const EmailValidator = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const EmailTextFieldValidator = (val) => {
    return EmailValidator(val) ? null : __("validator.invalid-email");
}

export const PasswordValidator = (password) => {
    return password.length >= 8;
}

export const PasswordTextFieldValidator = (val) => {
    return PasswordValidator(val) ? null : __("validator.invalid-password");
}

export const RequiredValidator = (val) => {
    return val && val !== "";
}
export const RequiredTextFieldValidator = (val) => {
    return RequiredValidator(val) ? null : __("validator.required");
}

export const PhoneValidator = (val) => {
    return !!val;
}
export const PhoneTextFieldValidator = (val) => {
    return PhoneValidator(val) ? null : __("validator.phone-needs-prefix");
}

export const CardNumberValidator = (val) => {
    const regex = /^[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}$/;
    return regex.test(val);
}
export const CardNumberTextFieldValidator = (val) => {
    return CardNumberValidator(val) ? null : __("validator.wrong-card-number");
}
export const CardExpValidator = (val) => {
    const regex = /^(01|02|03|04|05|06|07|08|09|10|11|12)\/[0-9]{2}$/;
    return regex.test(val);
}
export const CardExpTextFieldValidator = (val) => {
    return CardExpValidator(val) ? null : __("validator.wrong-card-exp");
}
export const CardCvvValidator = (val) => {
    const regex = /^[0-9]{3}$/;
    return regex.test(val);
}
export const CardCvvTextFieldValidator = (val) => {
    return CardCvvValidator(val) ? null : __("validator.wrong-card-cvv");
}

export const ArrayMinRequiredValidator = (val, min = 0, max = 9999) => {
    if(!val) return false;
    return (min <= val.length) && (val.length <= max);
}

export const CompanyValidator = (company) => {
    return CompanyValidationErrors(company).length === 0;
}
const CompanyAddressValidator = (address) => {
    return RequiredValidator(address.type) && RequiredValidator(address.address) && RequiredValidator(address.zip) && RequiredValidator(address.province)
        && RequiredValidator(address.country);
}
export const CompanyValidationErrors = (company) => {
    let errors = [];
    if(!RequiredValidator(company.name)) errors.push("validation.company.name");
    if(!RequiredValidator(company.vat)) errors.push("validation.company.vat");
    if(!RequiredValidator(company.employees)) errors.push("validation.company.employees");
    if(!RequiredValidator(company.osaCenter)) errors.push("validation.company.osaCenter");
    if(!RequiredValidator(company.referenceSector)) errors.push("validation.company.referenceSector");
    if(!PhoneValidator(company.phone)) errors.push("validation.company.phone");
    if(!EmailValidator(company.email)) errors.push("validation.company.email");
    if(!ArrayMinRequiredValidator(company.address, 1)) errors.push("validation.company.min_address")
    if(company.address && company.address.map(i => CompanyAddressValidator(i)).filter(i => !i).length !== 0) errors.push("validation.company.address")
    return errors;
}


export const ProfileValidator = (data) => {
    return ProfileValidationsErrors(data).length === 0;
}
export const ProfileValidationsErrors = (data) => {
    let errors = [];
    if(!RequiredValidator(data.firstName)) errors.push("validation.profile.firstName");
    if(!RequiredValidator(data.lastName)) errors.push("validation.profile.lastName");
    if(!RequiredValidator(data.gender)) errors.push("validation.profile.gender");
    if(!RequiredValidator(data.office)) errors.push("validation.profile.office");
    if(!PhoneValidator(data.phone)) errors.push("validation.profile.phone");
    if(!ArrayMinRequiredValidator(data.languages, 1)) errors.push("validation.profile.languages");
    if(!ArrayMinRequiredValidator(data.skills, 3)) errors.push("validation.profile.skills");
    if(!ArrayMinRequiredValidator(data.interests, 3)) errors.push("validation.profile.interests");
    return errors;
}